function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17",
  role: "img"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M8 14.134A1.072 1.072 0 1 0 8 11.99 1.072 1.072 0 0 0 8 14.134"
  }), /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.4 2.25C2.4 1.284 3.183.5 4.147.5h7.706c.965 0 1.747.784 1.747 1.75v12.5c0 .966-.782 1.75-1.747 1.75H4.147A1.75 1.75 0 0 1 2.4 14.75zM4.147 2a.25.25 0 0 0-.25.25v12.5c0 .138.113.25.25.25h7.706a.25.25 0 0 0 .25-.25V2.25a.25.25 0 0 0-.25-.25z",
    clipRule: "evenodd"
  })]
}));
export default SvgComponent;